import React, { useState, useEffect } from 'react';
import ShowcaseCard from '../components/ShowcaseCard';
import { ShowcaseProvider, type ShowcaseItem } from '../utils/ShowcaseProvider';
import '../components/ShowcaseCard.css';

function PageShell({ children }: { children: React.ReactNode }) {
    return (
        <div className="showcase-page">
            <div className="page-title">
                <div className="container">
                    <h1>Showcase</h1>
                    <p>Community examples and projects. Each card links to its folder in the repository.</p>
                </div>
            </div>
            <section className="section">
                <div className="container">{children}</div>
            </section>
        </div>
    );
}

function Showcase() {
    const [items, setItems] = useState<ShowcaseItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);
        ShowcaseProvider.getInstance()
            .GetShowcases()
            .then((data) => {
                if (!cancelled) setItems(data);
            })
            .catch((err) => {
                if (!cancelled) {
                    setError(err instanceof Error ? err.message : 'Failed to load showcases');
                    setItems([]);
                }
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => { cancelled = true; };
    }, []);

    if (loading) {
        return (
            <PageShell>
                <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading…</span>
                    </div>
                    <p className="mt-2 text-muted">Loading showcases…</p>
                </div>
            </PageShell>
        );
    }

    if (error) {
        return (
            <PageShell>
                <div className="alert alert-danger">{error}</div>
            </PageShell>
        );
    }

    return (
        <PageShell>
            {items.length === 0 ? (
                <p className="text-muted text-center py-5">No showcases available yet.</p>
            ) : (
                <div className="showcase-grid">
                    {items.map((item) => (
                        <ShowcaseCard key={item.slug} item={item} />
                    ))}
                </div>
            )}
        </PageShell>
    );
}

export default Showcase;
